import React, { useState } from 'react';
import PainPoint from './PainPoint';
import Taby from './Taby';
import LatestSdk from './LatestSdk';
import imgDBParams from '../../assets/Kiponos-DB-Params.webp'
import './AboutKiponos.css';

const HeaderSection = ({show, setShow}) => {  
  return (
    <div className="header-section">
      <Taby code='what' title='What is Kiponos?'    show={show} setShow={setShow} />
      <Taby code='how'  title='How Does It Work?'   show={show} setShow={setShow} />
      <Taby code='feat' title='Features'            show={show} setShow={setShow} />
    </div>
  );
} 

const WhatIsKiponosSection = () => (
  <div className="section what-is-kiponos">
    <h2>Real-time Configuration Management</h2>
    <p>We free developers from the chaos of application configurations by solving key pain points:</p>
    <div className='subHeader'>
      <PainPoint title='SDK with Realtime Updates' notes='Your SDK always have the latest config values in realtime, delta changes are instantly dispatched to all team members and SDKs'/>
      <PainPoint title='Tree Structured' notes='Configs are structured in the familiar style of a file system with folders and items'/>
      <PainPoint title='Team-Env-Role Based Access' notes='Configs are accessed only by relevant team members, appropriate role, and active Environment. A User can be in multiple teams'/>
      <PainPoint title='Manage Multiple Environments' notes='Clear and unique definition: Application → Release → Environment → Config Variant'/>
    </div> 
    <p/>
    <p><strong>Why Kiponos?</strong></p>
    <div>      
      SDK keeps the latest config values in memory, updated in real-time. So fetching any config item is done locally! directly from the SDK in-memory map.
      <p/>
      Obvioulsy no rebuilds, no redeployments, no restarts. Wether it's your docker container, mobile app, SpringBoot server - they always have the latest configs. Instanly. In realtime!
      <p/>
      No more config files, no more environment variables, no more properties files, no more yamls, shmamels, (and definitely no more xmls!)
      <p/>
      No setup. All you need is our SDK fetched automatically from maven repository and start defining your configs data online.
      <p/>
      * Coming up on our next release - Hierarchies so for example the QA environment inherits all the Staging configs and overrides only the config items appropriate to QA.
    </div>

    <div className='sampleDBParams'>
      <img className='imgSampleDBParams' src={imgDBParams} alt='Kiponos DB Params Config Tree Sample' />
    </div>
  </div>
);


const HowItWorksSection = () => (
  <div className="section how-it-works">
    <div style={{display:'flex', flexDirection:'row', justifyContent: 'flex-start', alignItems: 'baseline', gap:16}}>
      <PainPoint title='Include our SDK' notes='You include the SDK name in your build. The latest is: '/> <LatestSdk />
    </div>
    <PainPoint title='Define your envronments' notes='In your account, A Simple wizard guides you on defining your envronments and their configs'/>
    <PainPoint title='Get SDK Tokens' notes='We generate id and access tokens for the SDK associated and valid per unique team and environment'/>
    <PainPoint title="And Boom! That's it!" notes='Any config changes you do on the web admin, are instantly, in realtime dispatched to your SDK by WebSockets'/>
        
    <h3 style={{marginTop: 24, backgroundColor: '#30409099', padding: 16, borderRadius: 8}}>Access Permissions are based on Team & Role on the currently Selected Environment</h3>
    <ul>
      <li><strong>Alice from R&D Team:</strong> Admin for R&D Team, but Read-Only for the QA Team</li>
      <li><strong>Bob from QA Team:</strong>Read-Only for R&D Team, but Write acees for QA Team</li>
      <li><strong>Charlie from Marketing Team:</strong> Write Permissions on Marketing Team, But No Access on any others</li>
    </ul>

    <h3 style={{marginTop: 24, backgroundColor: '#30409099', padding: 16, borderRadius: 8}}>Using the Java SDK</h3>
    <p>Compatible with frameworks like SpringBoot, the SDK offers powerful features:</p>

    <h4>Fetching Config Values</h4>
    <pre style={{backgroundColor: '#101010'}}><code >{`Kiponos kiponos = Kiponos.createForCurrentTeam();
String savePath = kiponos.get("save-dir-path");

KiponosFolder postgresFolder = kiponos.path("Server", "DB", "PostgreSql");
String dbHost = postgresFolder.get("host");
int dbPort = postgresFolder.getInt("port");`}</code></pre>

    <h4>Navigating the Tree Structure</h4>
    <p>Organizing configurations in a tree structure with folders and items. Use the SDK to navigate:</p>
    <pre style={{backgroundColor: '#101010'}} ><code>{`sdk.folder("folder-name").get("key-name");
sdk.path("folder-name", "sub-folder-name", "nested-sub-folder-name").getInt("key-name-of-number");
KiponosFolder serverFolder = sdk.path("my-project", "server");
String serverHost = serverFolder.get("host");
int port = serverFolder.getInt("port");`}</code></pre>

    <h4>Listening for Config Changes</h4>
    <p>React to updates in real-time:</p>
    <pre style={{backgroundColor: '#101010'}}><code>{`kiponos.afterValueChanged(valueChangedInfo -> {
    if (valueChangedInfo.key.equals("dbHost")) {
        disconnectPostgress();
        reconnectPostgressByCurrentHostAndPort();
    }
});`}</code></pre>

    <h4>Write API</h4>
    <p>Create and modify configurations dynamically:</p>
    <pre style={{backgroundColor: '#101010'}}><code>{`sdk.createFolder("new-folder-name");
sdk.set("max-queue-size", "5000");
KiponosFolder mq = sdk.folder("rabbit-mq");
mq.set("topic-path", "/topic/notifications");`}</code></pre>
  </div>
);

const FeaturesSection = () => (
  <div className="section-features">
    <div className='features-main'>
      <PainPoint title='Realtime Configs' notes='Updates are instantly saved on a "Field" level, any value update, any key renamed, any folder created, etc.' />
      <PainPoint title='Role Based Access Control' notes='Permissions Based not only on Role, but combination of Role Per Team On the selected environment' />
      <PainPoint title='Unique Environment Definition' notes='Uniquely defined by "Application Name" → "Release" → "Env Name" → "Config Name"' />
      <PainPoint title='Listeners on Config Updates' notes='The SDK support registering listeners for any config change, e.g: sdk.afterValueUpdated(..),  sdk.afterKeyDeleted(..), etc.' />
      <PainPoint title='WebSockets Framework' notes='The SDK uses our WebSockets framework to dispatch updates instantly, with virtually no overhead' />      
    </div>

    <h2 style={{marginTop: 32, marginBottom: 24}}>What can be done with Realtime Configs?</h2>
    <h3 style={{marginTop: 32, marginBottom: 24}}>Implement using the SDK:</h3>

    <div className='features-list'>
      <PainPoint title='Validations' notes='Leverage Kiponos power of instant updates to manipulate your app validations like turn on/off or modify the validation params in realtime' />
      <PainPoint title='i18n & l10n' notes='Realtime localization manipulation, modify translated text, icons.' />
      <PainPoint title='SQL Statements' notes='Modify your server SQL queries in realtime' />
      <PainPoint title='Log Control' notes='Modify your application log levels in realtime' />
      <PainPoint title='Matrics with zero latency' notes='The power of our WebSockets framework enable metrics dispatches with virtually zero overhead' />
      <PainPoint title='Realtime Behavior Analysis' notes='Error counters and thresholds based decisions'/>    
    </div>

    <h2 style={{marginTop: 32, marginBottom: 24}}>More features next on coming releases:</h2>

    <div className='features-next'>
      <PainPoint title='Configs Hierarchies' notes='Start with a common "Factory Settings" config for your application, then override config items on "child" configs either on the same environment or others' />
      <PainPoint title='Production Debug Tables' notes='The SDK can be used to keep track on important variables in your code, watching them constanly online as a group' />
      <PainPoint title='Configs Insight' notes='AI Insight on your configurations' />
      <PainPoint title='Known products and services configs' notes='E.g: Recommended optimal settings for databases like Oracle, PostgreSql, MySql, or Queues, like RabbitMQ, ActiveMQ, etc' />
      <PainPoint title='Community Public Congigs' notes='Public Teams anyone can join to get instant updates in realtime, any organization would be able to define for everyone'/>
    </div>

    <div className='features-diagram'>
      <ul>
        <li><strong>Configuration Hierarchy:</strong> Team → Application → Release → Environment → Configuration.</li>
        <li><strong>Example Config Tree:</strong></li>
      </ul>
      <div className="tree-view">
        <ul>
          <li>Alice's Team
            <ul>
              <li>Medical Server
                <ul>
                  <li>Ver 3.2a
                    <ul>
                      <li>Staging Integ-01
                        <ul>
                          <li>Factory Settings</li>
                          <li>Performance Optimized</li>
                        </ul>
                      </li>
                      <li>Production
                        <ul>
                          <li>Government-Security-Settings</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>Bob's R&D
            <ul>
              <li>Medical Mobile App
                <ul>
                  <li>Beta
                    <ul>
                      <li>Charlie's Local Dev
                        <ul>
                          <li>Fix-Get-User</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
);

const CallToAction = () => (
  <div className="call-to-action">
    <button className="get-started-btn">Get Started with Kiponos</button>
  </div>
);

const AboutKiponos = () => {
  const [show, setShow] = useState('what');

  return (
    <div className="about-page">
      <HeaderSection show={show} setShow={setShow}/>
      { Boolean(show === 'what') && <WhatIsKiponosSection />}
      { Boolean(show === 'how') && <HowItWorksSection />}
      { Boolean(show === 'feat') && <FeaturesSection />}
    </div>
  );
}

export default AboutKiponos;